const StartTacoMatch = async (configData) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/Start`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(configData)
        });
        if (!response.ok) {
            const error = await response.json().catch(() => ({}));
            return { success: false, message: error.message || 'Error al iniciar la taquiza.' };
        }
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de red al conectar con el servidor.' };
    }
};

const ResetTacoMatch = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/Reset`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        return { success: response.ok, message: response.ok ? '' : 'Error al reiniciar.' };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

const ShowTacoFrontPage = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}Tacos/ShowFrontPage`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        });
        return { success: response.ok, message: response.ok ? '' : 'Error al mostrar la portada' };
    } catch (error) {
        return { success: false, message: 'Error de red.' };
    }
};

export { StartTacoMatch, ResetTacoMatch, ShowTacoFrontPage };